var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _vm.structuralElement
    ? _c("sidebar-widget", {
        attrs: {
          title: _vm.$gettext("Export"),
        },
        scopedSlots: _vm._u(
          [
            {
              key: "content",
              fn: function fn() {
                return [
                  _vm.structuralElement
                    ? _c(
                        "ul",
                        {
                          staticClass:
                            "widget-list widget-links cw-export-widget",
                        },
                        [
                          _vm.showExportArchiv
                            ? _c(
                                "li",
                                {
                                  staticClass: "cw-export-widget-export",
                                },
                                [
                                  _c(
                                    "button",
                                    {
                                      on: {
                                        click: _vm.exportElement,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(
                                            _vm.$gettext("Seiten exportieren")
                                          ) +
                                          "\n                "
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showExportPdf
                            ? _c(
                                "li",
                                {
                                  staticClass: "cw-export-widget-export-pdf",
                                },
                                [
                                  _c(
                                    "button",
                                    {
                                      on: {
                                        click: _vm.pdfElement,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(
                                            _vm.$gettext(
                                              "PDF-Dokument erstellen"
                                            )
                                          ) +
                                          "\n                "
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showOer
                            ? _c(
                                "li",
                                {
                                  staticClass: "cw-export-widget-oer",
                                },
                                [
                                  _c(
                                    "button",
                                    {
                                      on: {
                                        click: _vm.oerElement,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(
                                            _vm.$gettext(
                                              "Auf OER Campus veröffentlichen"
                                            )
                                          ) +
                                          "\n                "
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.showExportArchiv &&
                          !_vm.showExportPdf &&
                          !_vm.showOer
                            ? _c("li", [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.$gettext(
                                        "Keine Exportoptionen verfügbar"
                                      )
                                    ) +
                                    "\n            "
                                ),
                              ])
                            : _vm._e(),
                        ]
                      )
                    : _vm._e(),
                ]
              },
              proxy: true,
            },
          ],
          null,
          false,
          1128646410
        ),
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }